import { DITypes, LocalStorageKeys } from "@/core/@types/types";
import { diContainer } from "@/core/di";
import { IHttpMiddlewareIntercept } from "../protocols/types";
import useStorage from "@/core/plugins/useStorage";

const handleExpiredCheckpoint = (lastSave: string): boolean => {
  const dataAtual = new Date();
  const ultimoCheckpoint = new Date(lastSave);

  const minutosDataAtual = dataAtual.getMinutes();
  const minutosUltimoCheckpoint = ultimoCheckpoint.getMinutes();

  const minutos = minutosDataAtual - minutosUltimoCheckpoint;

  const tempoParaValidar = 1;

  const isRevalidarToken = minutos < 0 || minutos > tempoParaValidar;

  return isRevalidarToken;
};

const saveCurrentDate = () =>
  useStorage().set(LocalStorageKeys.LastChanged, new Date().toString());

function httpInterceptor() {
  //é necessário os argumentos para o decorator, mesmo não usando
  // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  return (
    // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
    target: any,
    // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
    memberName: string,
    // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
    propertyDescriptor: PropertyDescriptor
  ) => {
    const originalMethod = propertyDescriptor.value;

    propertyDescriptor.value = async function (...args: any[]) {
      if (import.meta.env.DEV) return originalMethod.apply(this, args);

      const lastSave = useStorage().get(LocalStorageKeys.LastChanged); // Acho que aqui deve ser uma entidade que vai lidar com a lógica da ultima vez que foi salvo

      const naoPossuiCheckpoint = !lastSave || lastSave === "";

      if (naoPossuiCheckpoint) {
        saveCurrentDate();
      } else {
        const tokenExpirou = handleExpiredCheckpoint(lastSave);

        if (!tokenExpirou) return originalMethod.apply(this, args);

        saveCurrentDate();
      }

      const intercept = diContainer.get<IHttpMiddlewareIntercept>(
        DITypes.HTTP_MIDDLEWARE_INTERCERPT
      );

      await intercept.sendFinancasToken();

      return originalMethod.apply(this, args);
    };

    return propertyDescriptor;
  };
}

export { httpInterceptor };
